// export const API_URL = "http://localhost:3000/api";
// export const API_URL_PDF = "http://localhost:3000";

export const API_URL = "https://siap.ptgam.com/api";
export const API_URL_PDF = "https://siap.ptgam.com";

// export const API_URL = "https://api-survey.ptgam.com/api";
// export const API_URL_PDF = "https://api-survey.ptgam.com";
